import React, { useEffect, useState } from "react";
import { client } from "../../Client";
import AppWrap from "../../wrapper/AppWrap";
import MotionWrap from "../../wrapper/MotionWrapper";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import "swiper/css/bundle";

// Import Swiper styles

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

// import required modules
import { EffectCoverflow, Pagination } from "swiper";

import "./Work.scss";
// import FilteredWork from './FilteredWork';
import SwiperSection from "./SwiperSection";

import pinky from "../../assets/img/tranparent.png";
import AboutMe from "../About/AboutMe";
import Skill from "../About/Skill";

const Work = () => {
  const tags = [
    "HTML",
    "CSS",
    "Bootstrap",
    "Tailwind Css",
    "Material UI",
    "Chakra UI",
    "Vanila Js",
    "TypeScript",
    "React JS",
    "Next Js",
    "MongoDB",
    "Node Js",
    "Express Js",
    "Stripe",
    "Sanity",
    "git",
    "All",
  ];
  const [about, setAbout] = useState("webApp");
  const [activeFilter, setActiveFilter] = useState("All");
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);

  useEffect(() => {
    const query = '*[_type=="works"]';

    client.fetch(query).then((data) => {
      setWorks(data);
      setFilterWork(data);
      console.log(data);
    });
  }, []);

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === "All") {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };
  return (
    <div>
      <div className="title-section">
        <h1 className="text-secondary">
          <span>skills</span> & <span> projects</span>
        </h1>
        <span className="title-bg">experience</span>
      </div>
      <div>
        <div data-aos="slide-right">
          <Stack
            sx={{ justifyContent: "center", mb: 4 }}
            spacing={3}
            direction="row"
          >
            <Button
              style={{ backgroundColor: about === "webApp" ? "#1976d247" : "" }}
              onClick={() => setAbout("webApp")}
              sx={{
                fontWeight: "bold",
              }}
              variant="outlined"
            >
              web App
            </Button>

            <Button
              onClick={() => setAbout("mobileApp")}
              style={{ backgroundColor: about === "mobileApp" ? "#1976d247" : "" }}
              sx={{
                fontWeight: "bold",
              }}
              variant="outlined"
            >
              mobile App
            </Button>

            
            <Button
              onClick={() => setAbout("dApp")}
              style={{ backgroundColor: about === "dApp" ? "#1976d247" : "" }}
              sx={{
                fontWeight: "bold",
              }}
              variant="outlined"
            >
              dApp
            </Button>

            
          </Stack>
        </div>
        <div data-aos="slide-left">
          {about === "webApp" && <SwiperSection />}
          {about === "mobileApp" && <div><h1 className="text-white">Still learning! no app built yet..</h1></div>}
          {about === "dApp" && <div><h1 className="text-white">Still learning! no app built yet..</h1></div>}
        </div>
      </div>
    </div>
  );
};

export default AppWrap(
  MotionWrap(Work, "app__works"),
  "skills",
  "app__primarybg"
);
